<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Aguarde :show="showAguarde"></Aguarde>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-form @submit.prevent="getNota" class="border-bottom mb-3">
              <div class="row">
                <div class="col-md-3">
                  <b-form-group label="Ano" label-for="not_emissao_ano">
                    <input
                        id="not_emissao_ano"
                        v-model="filtro.not_emissao_ano"
                        v-mask="'####'"
                        type="text"
                        maxlength="4"
                        class="form-control"
                        placeholder="Ano">
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                      label="Número"
                      label-for="fnot_numero">
                    <input
                        id="fnot_numero"
                        v-model="filtro.not_numero"
                        type="text"
                        maxlength="11"
                        class="form-control"
                        placeholder="Nº final da nota">
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                      label="Competência Inicial"
                      label-for="sep_competencia_inicial">
                    <input
                        id="sep_competencia_inicial"
                        v-model="filtro.sep_competencia_inicial"
                        v-mask="'##/####'"
                        type="text"
                        maxlength="7"
                        class="form-control"
                        placeholder="Mês/Ano">
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                      label="Competência Final"
                      label-for="sep_competencia_final">
                    <input
                        id="sep_competencia_final"
                        v-model="filtro.sep_competencia_final"
                        v-mask="'##/####'"
                        type="text"
                        maxlength="7"
                        class="form-control"
                        placeholder="Mês/Ano">
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <b-form-group
                      label="Emissão Incial"
                      label-for="not_emissao_incial">
                    <input
                        id="not_emissao_incial"
                        v-model="filtro.not_emissao_incial"
                        v-mask="'##/##/####'"
                        type="text"
                        maxlength="10"
                        class="form-control"
                        placeholder="Dia/Mês/Ano">
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                      label="Emissão Final"
                      label-for="not_emissao_final">
                    <input
                        id="not_emissao_final"
                        v-mask="'##/##/####'"
                        v-model="filtro.not_emissao_final"
                        type="text"
                        maxlength="10"
                        class="form-control"
                        placeholder="Dia/Mês/Ano">
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                      label="Nº Nota Inicial"
                      label-for="not_numero_inicial">
                    <input
                        id="not_numero_inicial"
                        v-model="filtro.not_numero_inicial"
                        type="text"
                        v-mask="'###############'"
                        maxlength="15"
                        class="form-control"
                        placeholder="Número completo">
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                      label="Nº Nota Final"
                      label-for="not_numero_final">
                    <input
                        id="not_numero_final"
                        v-model="filtro.not_numero_final"
                        type="text"
                        maxlength="15"
                        v-mask="'###############'"
                        class="form-control"
                        placeholder="Número completo">
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <b-form-group label="ISS Retido" label-for="sep_iss_retido">
                    <select id="sep_iss_retido"
                            @change="getNota"
                            v-model="filtro.sep_iss_retido"
                            class="custom-select" type="text">
                      <option value="0">Todos</option>
                      <option value="S">Sim</option>
                      <option value="N">Não</option>
                    </select>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                      label="Nome/Razão Tomador"
                      label-for="fsep_razao_social_tomador">
                    <input
                        id="fsep_razao_social_tomador"
                        v-model="filtro.sep_razao_social_tomador"
                        type="text"
                        maxlength="20"
                        class="form-control"
                        placeholder=" ">
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                      label="CPF/CNPJ do Tomador">
                    <the-mask class="form-control" v-model="filtro.sep_cpf_cnpj_tomador"
                              :mask="['###.###.###-##', '##.###.###/####-##']"/>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                      label="'"
                      class="text-white">
                    <button type="submit"
                            class="btn btn-label btn-block btn-primary"><i
                        class="bx bx-search label-icon"></i>
                      Pesquisar
                    </button>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <button type="button"
                          @click="alterMarcarTodos()"
                          class="btn btn-label btn-sm btn-sm mr-2 mb-2 btn-secondary"><i
                      class="bx bx-check-double label-icon"></i>
                    <span v-show="!marcar_todos">Marcar Todos</span>
                    <span v-show="marcar_todos">Desmarcar Todos</span>
                  </button>
                  <button type="button"
                          title="Verificar pagamentos"
                          @click="realizar_fechamento()"
                          class="btn btn-label btn-sm btn-sm mr-2 mb-2 btn-success"><i
                      class="bx bx-analyse label-icon"></i>
                    Realizar Fechamento
                  </button>
                </div>
              </div>
            </b-form>
            <div v-show="!list_notas.length || list_notas.length < 1" role="alert" aria-live="polite"
                 aria-atomic="true" class="alert alert-primary text-center">
              Sem notas fiscais para realizar o fechamento parcial
            </div>
            <div v-for="g in list_notas" :key="g.tps_codigo" class="row">
              <div class="col-md-12 mb-3 border-bottom border-secondary">
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group :label="(g.not_numero==='0')?'RANFS':'Nota Fiscal'">
                      <b-form-checkbox
                          v-bind:id="'id_verificacao'+g.sep_codigo"
                          v-model="g.verificar"
                          :unchecked-value="false"
                          class="custom-checkbox text-dark custom-checkbox-outline custom-checkbox-primary">
                        {{ (g.not_codigo === '0') ? '' : g.not_numero }}
                        {{ (g.ran_codigo === '0') ? '' : g.ran_codigo.padStart(15, "0") }}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group label="Emissão - Competência">
                      <h6 class="mb-0">
                        <span class="text-body font-weight-bold">{{ g.emissao | formatDate }} - </span>
                        <span class="text-body font-weight-bold">{{ g.sep_competencia | formatDateCompetencia }}</span>
                      </h6>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group label="Situação">
                      <h6 class="mb-0">
                        <span v-show="g.soc_codigo" class="badge badge-danger font-size-12">Cancelada</span>
                        <span v-show="!g.soc_codigo"
                              class="badge badge-success font-size-12">Emitida</span>
                      </h6>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group :label="(g.pes_incidencia==='T')?'CPF/CNPJ Prestador':'CPF/CNPJ Tomador'">
                      <h6 v-show="g.pes_incidencia==='T'" class="mb-0">
                <span v-if="g.sep_cpf_cnpj_prestador.length < 12">
                  {{ g.sep_cpf_cnpj_prestador | VMask('###.###.###-##') }}</span>
                        <span v-else>{{ g.sep_cpf_cnpj_prestador| VMask('##.###.###/####-##') }}</span>
                      </h6>
                      <h6 v-show="g.pes_incidencia==='P'" class="mb-0">
                <span v-if="g.sep_cpf_cnpj_tomador.length < 12">
                  {{ g.sep_cpf_cnpj_tomador | VMask('###.###.###-##') }}</span>
                        <span v-else>{{ g.sep_cpf_cnpj_tomador| VMask('##.###.###/####-##') }}</span>
                      </h6>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group
                        :label="(g.pes_incidencia==='T')?'Nome/Razao Social Prestador':'Nome/Razao Social Tomador'">
                      <h6 v-show="g.pes_incidencia==='P'" class="mb-0">{{ g.sep_razao_social_tomador }}</h6>
                      <h6 v-show="g.pes_incidencia==='T'" class="mb-0">{{ g.sep_razao_social_prestador }}</h6>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group label="Valor da Nota">
                      <h6 class="mb-0">{{ g.sep_valor | formatNumeroBr }}</h6>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group label="ISS Retido">
                      <h6 class="mb-0">{{ (g.sep_iss_retido === 'S') ? 'Sim' : 'Não' }}</h6>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group label="Valor do Débito">
                      <h5 class="mb-0 text-danger font-weight-bold">{{ g.sep_iss | formatNumeroBr }}</h5>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <button v-show="g.ran_codigo==='0'" type="button" class="btn btn-dark btn-sm mb-2 mr-2">
                      <i class="mdi mdi-file-pdf-outline"></i> Visualizar NFS-e
                    </button>
                    <button v-show="g.not_codigo==='0'" type="button" class="btn btn-dark btn-sm mb-2 mr-2">
                      <i class="mdi mdi-file-pdf-outline"></i> Visualizar Ranfs
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <p class="text-dark mb-0 font-weight-bold">Valor total: {{ valor_total | formatNumeroBr }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <paginate
                    :page-count="total_paginas"
                    :page-range="3"
                    :margin-pages="3"
                    :click-handler="proximaPagina"
                    :prev-text="'Página anterior'"
                    :next-text="'Próxima página'"
                    :prev-link-class="'page-link'"
                    :next-link-class="'page-link'"
                    :page-link-class="'page-link'"
                    :container-class="'pagination pagination-rounded justify-content-center mt-4'"
                    :page-class="'page-item'">
                </paginate>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/router/layouts/main";
import Aguarde from "@/components/widgets/aguarde";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import Paginate from 'vuejs-paginate'
import {TheMask} from 'vue-the-mask'
import {listNotasTributaveis} from "@/api/nfse/nota";
import {notifyErro, notifySucesso} from "@/helps/notificacao";
import {fechamentoParcial} from "@/api/financeiro/guia";

export default {
  page: {
    title: "Fechamento Parcial",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Aguarde,
    TheMask,
    Paginate
  },
  data() {
    return {
      title: 'Fechamento Parcial',
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Fechamento Parcial',
          active: true,
        },
      ],
      showAguarde: false,
      httpSend: false,
      list_notas: [],
      marcar_todos: true,
      filtro: {
        eco_codigo: null,
        pagina: 1,
        nota_pagina: "50",
        not_emissao_ano: "",
        not_numero: "",
        sep_competencia_inicial: "",
        sep_competencia_final: "",
        not_emissao_incial: "",
        not_emissao_final: "",
        not_numero_inicial: "",
        not_numero_final: "",
        sep_exigibilidade_iss: "0",
        not_cancelada: "0",
        sep_iss_retido: "0",
        sep_cpf_cnpj_tomador: "",
        sep_razao_social_tomador: "",
      },
      total_paginas: 0,
    };
  },
  created() {
    if (this.empresa) {
      this.filtro.eco_codigo = this.empresa.eco_codigo;
      this.getNota();
    }
  },
  computed: {
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
    valor_total: {
      get: function () {
        return this.list_notas
            .map(p => Number(p.sep_iss))
            .reduce((sum, current) => sum + current, 0);
      }
    }
  },
  methods: {
    proximaPagina(pageNum) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.filtro.pagina = pageNum;
      this.getNota()
    },
    getNota() {
      this.httpSend = true;
      listNotasTributaveis(this.empresa.eco_codigo, this.filtro).then(result => {
        this.total_paginas = result.dados.paginas;
        this.list_notas = result.dados.notas;
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    alterMarcarTodos() {
      this.marcar_todos = !this.marcar_todos;
      this.list_notas.forEach(function (notas) {
        notas.verificar = this.marcar_todos;
      }, this);
    },
    realizar_fechamento() {
      const notas = this.list_notas.filter((n) => n.verificar);
      const sep_fechamento = [];
      if (notas.length < 1) {
        notifyErro("Erro", "Nenhum débito selecionado")
        return
      }
      notas.forEach(function (n) {
        sep_fechamento.push(parseInt(n.sep_codigo))
      });
      this.showAguarde = true;
      fechamentoParcial(this.empresa.eco_codigo, sep_fechamento).then(result => {
        if (result.status) {
          notifySucesso("Fechamento Parcial", result.mensagem)
          this.$router.push({name: 'contribuinte-financeiro-guia'})
        } else {
          notifyErro("Erro", result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.showAguarde = false;
      })
    },
  }
}
;
</script>


